import { FC } from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";

interface TabsProps {
  tab: number;
  setTab: (value: number) => void;
  tabsLabels: string[];
}

export const Tabs: FC<TabsProps> = ({ tab, setTab, tabsLabels }) => (
  <div className={styles.tabs}>
    <div className={styles.tabsCounts}>
      {tabsLabels.map((label, index) => (
        <button
          key={label}
          type="button"
          className={classNames(styles.tabCount, {
            [styles.active]: tab === index,
          })}
          onClick={() => setTab(index)}
        >
          {index + 1}
        </button>
      ))}
    </div>
    <div className={styles.tabsLabels}>
      {tabsLabels.map((label, index) => (
        <button
          key={label}
          type="button"
          className={classNames(styles.tabLabel, {
            [styles.active]: tab === index,
          })}
          onClick={() => setTab(index)}
        >
          {label}
        </button>
      ))}
    </div>
  </div>
);
